import { CSSObject } from '@emotion/styled';

const generateStylesheetRules = <T extends Record<string, any>>(
	props: T,
	ruleEntries: string[],
) => {
	const style: CSSObject = {};

	ruleEntries.reduce((accumulator, current) => {
		if (props[current] !== undefined) {
			const styleKey = current.replace('$', '');
			accumulator[styleKey] = props[current];
		}
		return accumulator;
	}, style);

	return style;
};

export { generateStylesheetRules };
